import { instance as axios, setJwtToken } from "../../config/AxiosInstance"

// ---------------------Fetching CMS Api----------------------------------
export const fetchCountryListApi = async (data) => {
  const endPoint =
    `public/countries`
  return await axios.get(endPoint);
};

// ---------------------Fetching State List Api----------------------------------
export const fetchStateListApi = async (data) => {
  const endPoint =
    `public/states` +
    "?" +
    new URLSearchParams(data).toString();
  return await axios.get(endPoint);
};

// ---------------------Fetching State List Api----------------------------------
export const fetchCityListApi = async (data) => {
  const endPoint =
    `public/cities` +
    "?" +
    new URLSearchParams(data).toString();
  return await axios.get(endPoint);
};

//----------Categories List API (User Interest After User Registration)-----------
export const fetchCategoriesListApi = async (data) => {
  const endPoint = `public/categories` + "?" + new URLSearchParams(data).toString();
  return await axios.get(endPoint);
};

// ------------User Profile Detail API------------------------------------------
export const fetchUserDetailApi = async (data) => {
  const endPoint =
    `user/account/my-profile` +
    "?" +
    new URLSearchParams(data).toString();
  return await axios.get(endPoint, setJwtToken());
};

// ------------GET CMS DATA-------------
export const fetchPublicCmsDataApi = async (data) => {
  const endPoint = `public/cms` + "?" + new URLSearchParams(data).toString();
  return await axios.get(endPoint, setJwtToken());
};

//-------------get-Join-Groups-data----when-signup----------
export const joinGroupSignupApi = async (data) => {
  const endPoint = `user/group/signup/list` + "?" + new URLSearchParams(data).toString();
  return await axios.get(endPoint, setJwtToken());
};

//-------------group-Member-List-APi---child-create-grp-------
export const childGroupMemberListAPi = async (data) => {
  const endPoint = `user/group-member/list` + "?" + new URLSearchParams(data).toString();
  return await axios.get(endPoint, setJwtToken());
};

//-------------notification-List-Api----------------------
export const notificationListApi = async (data) => {
  const endPoint = `user/notification/list` + "?" + new URLSearchParams(data).toString();
  return await axios.get(endPoint, setJwtToken());
};

//----------------------content-us------------------------
export const contentUsApi = async (data) => {
  const endPoint = `public/contact`;
  return await axios.post(endPoint, data, setJwtToken())
}